import gql from 'graphql-tag';

export default gql`
    mutation SaveCustomerParent($input: SaveCustomerParentInput) {
        saveCustomerParent(input: $input) {
            errors
        }
    }
`;
